import React, { useEffect, useState, useRef } from "react";
import { useAppDispatch } from "../../../../../store";
import { useSelector } from "react-redux";
import * as styles from "../../../../../styles/WholedataPage";

import { RootState } from "../../../../../reducer/index";
import axios from "axios";
import { Outersensors } from "../../../../../reducer/postpayloadtypes";

const BeforeData = ({ modal, setModal, filteredDiaryList }: any) => {
  const dispatch = useAppDispatch();
  const { TargetDiary, Farms, Targetfarms } = useSelector(
    (state: RootState) => state.post
  );
  let productcode = TargetDiary?.diaryClass.productCode; // 곤충 productcode
  let diaryType = TargetDiary?.diaryClass.diaryType; // 작업 종류
  let diaryId = TargetDiary?.diaryId; // 일지 페이지 ID
  let manageBoxId = TargetDiary?.manageBoxId; // 사육상자 ID

  console.log("이동 페이지 filteredDiaryList :: ", filteredDiaryList);

  // 일지 상세 페이지에서 호출과 등록 페이지에서 호출 구분
  if (!productcode || !diaryType || !diaryId) {
    const matchedDiary = filteredDiaryList[0];
    productcode = productcode || matchedDiary.diaryClass.productCode;
    diaryType = diaryType || matchedDiary.diaryClass.diaryType;
    diaryId = diaryId || matchedDiary.diaryId;
    manageBoxId = manageBoxId || matchedDiary.manageBoxId;
  }

  //이전 데이터 환경정보 가져오기
  //외기 환경정보
  let [outersensors, setOutersensors] = useState<any>();
  //사육실 내부 환경 정보
  let [consensor, setConsensor] = useState<any>();
  // 사육구역
  let [sectiondata, setSectiondata] = useState<any>();
  // 사육상자 내부 환경 정보
  let [boxsensor, setBoxsensor] = useState<any>();
  let [beforedata, setBeforedata] = useState<any>(null);
  useEffect(() => {
    // 외기(농장)
    if (filteredDiaryList[0].diaryEquips.dairyEquipFarm) {
      setOutersensors(filteredDiaryList[0].diaryEquips.dairyEquipFarm);
    }

    // 사육실
    if (filteredDiaryList[0].diaryEquips.diaryEquipContainer) {
      setConsensor(filteredDiaryList[0].diaryEquips.diaryEquipContainer);
    }

    // 구역
    if (filteredDiaryList[0].diaryEquips.diaryEquipSection) {
      setSectiondata(filteredDiaryList[0].diaryEquips.diaryEquipSection);
    }

    // 박스
    if (filteredDiaryList[0].diaryEquips.diaryEquipBox) {
      setBoxsensor(filteredDiaryList[0].diaryEquips.diaryEquipBox);
    }


    // setOutersensors(beforedata?.diaryEquips?.dairyEquipFarm);
    // setConsensor(beforedata?.diaryEquips?.diaryEquipBox);
    // setBoxsensor(beforedata?.diaryEquips?.diaryEquipContainer);
  }, [beforedata]);

  useEffect(() => {
    // 이전데이터 가져오기
    axios
      .get(
        `/ifactory/api/diary/past/${diaryId}/${manageBoxId}?diaryType=${diaryType}&productCode=${productcode}`
      )
      .then((res) => {
        setBeforedata(res.data);

        // console.log("이전 데이터 호출 여부 확인 :: ", res.data);

      })
      .catch((error) => {
        console.log(error);
      });
  }, [TargetDiary]);

  return (
    <styles.BeforeDataModal
      className={modal === 1 ? "modal-open" : "modal-close"}
    >
      <div
        className="modal"
        onClick={() => {
          setModal(0);
				}}
      >
				<div className="modal-item">
          <styles.EnvironmentalCon>
            <styles.Environmentaltit>
              <p className="content-tit">환경정보</p>
            </styles.Environmentaltit>
            <styles.EnvironmentalHide>
              <styles.EnvironmentalBox>
                <p className="EnvironmentalBox-tit Spoqa500">
                  <span className="c-22c197 Spoqa500">외기</span> 환경정보
                </p>

                <styles.OutsideAirList>
                  {outersensors &&
                    outersensors?.map((sensors: Outersensors) => {
                      const windParser = (sensors: Outersensors) => {
                        let value = sensors.value;

                        if (
                          (value >= "0" && value <= "22.5") ||
                          (value > "337.5" && value <= "360")
                        ) {
                          return "북";
                        }
                        if (value > "22.5" && value <= "67.5") return "북동풍";
                        if (value > "67.5" && value <= "112.5") return "동풍";
                        if (value > "112.5" && value <= "157.5")
                          return "남동풍";
                        if (value > "157.5" && value <= "202.5") return "남풍";
                        if (value > "202.5" && value <= "247.5")
                          return "남서풍";
                        if (value > "247.5" && value <= "292.5") return "서풍";
                        if (value > "292.5" && value <= "337.5")
                          return "북서풍";

                        return "NO DATA";
                      };

                      const snsrControl = (sensors: Outersensors) => {
                        let res = "";

                        // switch (sensors.code) {
                        //   case "RAINCHECK":
                        //     res = sensors.value === "1" ? "비" : "비 안옴";
                        //     break;
                        //   case "WINDDIR":
                        //     res = windParser(sensors);
                        //     break;
                        //   default:
                        //     res = sensors.value.toString();
                        // }

                        return res;
                      };

                      return (
                        <styles.OutsideAirListItem>
                          <p className="outsideair-item-tit">{sensors.name}</p>
                          <p className="outsideair-item-content">
                            {/* {snsrControl(sensors)} */}
                            {sensors.value}
                            {sensors.unit}
                          </p>
                        </styles.OutsideAirListItem>
                      );
                    })}
                </styles.OutsideAirList>
              </styles.EnvironmentalBox>

              {consensor && consensor.length > 0 && (
                <styles.EnvironmentalBox>
                  <p className="EnvironmentalBox-tit Spoqa500">
                    <span className="c-22c197 Spoqa500">사육실</span> 내부
                    환경정보
                  </p>

                  <styles.EnvironmentalGrap>
                    {/* <styles.EnvironmentSample>
                      <div className="item">
                        <p className="sample bg-22C197"></p>
                        <p className="text">정상</p>
                      </div>
                      <div className="item">
                        <p className="sample"></p>
                        <p className="text">위험</p>
                      </div>
                    </styles.EnvironmentSample> */}

                    {consensor?.map((sensors: any) => {
                      let sensorcolor = "";
                      let fontcolor = "";

                      if (sensors?.status === 0) {
                        sensorcolor = "bg-22C197";
                        fontcolor = "22C197";
                      } else {
                        sensorcolor = "bg-FF0000";
                        fontcolor = "FF0000";
                      }

                      return (
                        <styles.EnvironmentalItem>
                          <p className="env-item-title">{sensors.name}</p>
                          <p className={`env-item-color `}>
                            <p className={`${sensorcolor}`}></p>
                          </p>
                          <p className={`env-item-value color-${fontcolor}`}>
                            {sensors.value}
                            {sensors.unit}
                          </p>
                        </styles.EnvironmentalItem>
                      );
                    })}
                  </styles.EnvironmentalGrap>
                </styles.EnvironmentalBox>
              )}


              {sectiondata && sectiondata.length > 0 && (
                <styles.EnvironmentalBox>
                  <p className="EnvironmentalBox-tit Spoqa500">
                    <span className="c-22c197 Spoqa500">사육구역</span> 내부 환경정보
                  </p>
                  <styles.EnvironmentalGrap>
                    {/* <styles.EnvironmentSample>
                      <div className="item">
                        <p className="sample bg-22C197"></p>
                        <p className="text">정상</p>
                      </div>
                      <div className="item">
                        <p className="sample"></p>
                        <p className="text">위험</p>
                      </div>
                    </styles.EnvironmentSample> */}
                    {sectiondata &&
                      sectiondata.map((sensor: any, idx: Number) => {
                        let sensorcolor = "";
                        let fontcolor = "";

                        sensorcolor = "bg-22C197";
                        fontcolor = "22C197";

                        if (sensor?.status === 0) {
                          sensorcolor = "bg-22C197";
                          fontcolor = "22C197";
                        } else {
                          sensorcolor = "bg-FF0000";
                          fontcolor = "FF0000";
                        }

                        // if (
                        //   sensor.value >= sensor.tagRange.alarmLowerLimit &&
                        //   sensor.value <= sensor.tagRange.alarmUpperLimit
                        // ) {
                        //   sensorcolor = "bg-22C197";
                        //   fontcolor = "22C197";
                        // } else {
                        //   sensorcolor = "bg-FF0000";
                        //   fontcolor = "FF0000";
                        // }


                        return (
                          <styles.EnvironmentalItem key={sensor?.diaryTagId}>
                            <p className="env-item-title">{sensor?.name}</p>
                            <p className={`env-item-color `}>
                              <p className={`${sensorcolor}`}></p>
                            </p>
                            <p className={`env-item-value color-${fontcolor}`}>
                              {sensor?.value}
                              {sensor?.unit}
                            </p>
                          </styles.EnvironmentalItem>
                        );
                      })}
                  </styles.EnvironmentalGrap>
                </styles.EnvironmentalBox>
              )}

              {boxsensor && boxsensor.length > 0 && (
                <styles.EnvironmentalBox>
                  <p className="EnvironmentalBox-tit Spoqa500">
                    <span className="c-22c197 Spoqa500">사육상자</span> 내부
                    환경정보
                  </p>

                  <styles.EnvironmentalGrap>
                    {/* <styles.EnvironmentSample>
                      <div className="item">
                        <p className="sample bg-22C197"></p>
                        <p className="text">정상</p>
                      </div>
                      <div className="item">
                        <p className="sample"></p>
                        <p className="text">위험</p>
                      </div>
                    </styles.EnvironmentSample> */}

                    {boxsensor?.map((sensor: any) => {
                      console.log("sensor!!:", sensor);

                      let sensorcolor = "";
                      let fontcolor = "";

                      if (sensor?.status === 0) {
                        sensorcolor = "bg-22C197";
                        fontcolor = "22C197";
                      } else {
                        sensorcolor = "bg-FF0000";
                        fontcolor = "FF0000";
                      }

                      return (
                        <styles.EnvironmentalItem>
                          <p className="env-item-title">{sensor.name}</p>
                          <p className={`env-item-color `}>
                            <p className={`${sensorcolor}`}></p>
                          </p>
                          <p className={`env-item-value color-${fontcolor}`}>
                            {sensor.value}
                            {sensor.unit}
                          </p>
                        </styles.EnvironmentalItem>
                      );
                    })}
                  </styles.EnvironmentalGrap>
                </styles.EnvironmentalBox>

              )}

            </styles.EnvironmentalHide>
          </styles.EnvironmentalCon>
        </div>
      </div>
    </styles.BeforeDataModal>
  );
};

export default BeforeData;
